export default __webpack_public_path__ + "static/media/6.0d82073d.jpg";